module.exports = __webpack_public_path__ + "img/slagpen.f0165400.png";